export const OurMission: React.FC = () => {
    return (
        <section id="about-us" className="section-content-block" style={{ scrollMarginTop: '5.2rem' }}>

        <div className="container  wow fadeIn">

            <div className="row">

                <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">

                        <div className="section-heading-wrapper no-padding">
                            <h2>Our <span>Mission</span></h2>
                            <hr />
                            <p className="margin-top-20">
                                The Black Hills Robotics Foundation is dedicated to enabling 6th through 12th grade students throughout the Black Hills to compete in Robotics.
                                By doing this, they are able to develop a passion for Mechanical, Electrical, Software Engineering and related disciplines.
                                All while learning additional real world "soft" skills that will lead to their success in any field like grit, leadership, teamwork, iteration, and managing stress.
                            </p>

                            <p>
                                We do this by helping new teams get started and by fundraising to support new and existing teams!
                            </p>
                             <div className="info-separotor">
                                <img src="images/signature.png" alt="" />
                                <p><strong>Jonathan Nelson</strong> <br/>President, Black Hills Robotics Foundation </p>
                            </div>

                        </div>

                </div>


                <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">

                    <img src="images/teams/2025-erd.jpg" style={{ borderRadius: 5 }} alt="" />
                    <p style={{ textAlign: 'center'}}>Congratulations to our 2025 HS Graduating Seniors!</p>

                </div>



            </div>

            <div className="row no-gutter margin-top-30">

                <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                    <div className="about-highlight-1">
                        <i className="fa fa-users"></i>
                        <div className="about-content">
                            <h3>Volunteering</h3>
                            <p className="about-text">We are 100% volunteers - with experience coaching robotics, helping parents and teachers become coaches and start teams in their community</p>
                        </div>
                    </div>
                </div>

                <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                    <div className="about-highlight-1 about-featured-block">
                        <i className="fa fa-hand-holding-dollar"></i>
                        <div className="about-content">
                            <h3>Fundraising</h3>
                            <p className="about-text">We bring together donors big and small throughout the Black Hills so teams and coaches can focus on growing and winning (not fund raising)</p>
                        </div>
                    </div>
                </div>

                <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                    <div className="about-highlight-1">
                        <i className="fa fa-briefcase"></i>
                        <div className="about-content">
                            <h3>Help & Support</h3>
                            <p className="about-text">We create a network effect so that coaches throught the black hills can share knowledge and best practices and ensure continuity for years to come.</p>
                        </div>
                    </div>
                </div>


            </div>

        </div>

    </section>
    );
}
